module.exports = __webpack_public_path__ + "static/media/cellphone_screen-analytics.5e503645.png";